import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import ImgProgress from '../../img/pricePage/ModernProcess.webp';

const ProjectProcess = () => {
  const { t } = useTranslation('prices');

  return (
    <section className="process section">
      <div className="container">
        <h2 className="title-2">
          {t('process.title')} <span>{t('process.titleAccent')}</span> {t('process.titleEnd')}
        </h2>
        <div className="steps-wrapper">
          <div className="steps-image">
            <img className="img-progress" alt="steps progress" src={ImgProgress} />
          </div>
          <div className="steps-block">
            <ol>
              {t('process.steps', { returnObjects: true }).map((step, i) => (
                <li key={i}>
                  <strong>{step.title}</strong> — {step.desc}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectProcess;
